import React from 'react'
import { Text } from 'components'
import classNames from 'classnames'
import styles from './Checkbox.module.scss'

const Checkbox = ({
  id = '',
  option,
  optionPosition = 'left',
  checked,
  onChange,
  className = '',
}) => (
  <label
    htmlFor={id}
    className={classNames(
      className,
      styles.container,
      styles[`option-${optionPosition}`]
    )}
  >
    <Text bold={checked}>{option}</Text>
    <input id={id} type="checkbox" checked={checked} onChange={onChange} />
    <span className={styles.checkmark} />
  </label>
)

export default React.memo(Checkbox)
